import { gsap } from "gsap";

class PrivateLabel {

    constructor (params) {
        // Init variables
	    this.$cache       = {};
	    this.$cache.main  = params.target;
		
		this.current = false;
		
		// Trigger init functions
		this.initCache();
		this.initEventsConst();
		this.registerEvents();
		
		this.init();
    }
	
	initCache() {
		this.$cache.window = $(window);
		this.$cache.html = $('html');
		this.$cache.body = this.$cache.html.find('body');
		this.$cache.wrap = this.$cache.body.find('.wrap');
		
		this.$cache.content = this.$cache.main.find('.private-content');
		this.$cache.left = this.$cache.content.find('.pc-left');
		this.$cache.items = this.$cache.left.find('.private-item');
		this.$cache.title = this.$cache.items.find('.pi-title');
		
		this.$cache.right = this.$cache.content.find('.pc-right');
		this.$cache.rightContent = this.$cache.right.find('.pcrc-content');
		this.$cache.itemsContent = this.$cache.rightContent.find('.item-content');
	}
	
	initEventsConst() {
		this.changeItemEvent = (e) => this.changeItem(e);
	}
	
	registerEvents() {
		this.$cache.title.on('click', this.changeItemEvent);
	}
	
	resize() {
		let bpLastValue = window.bp.lastValue;
		let bpValue = window.bp.value;
	
		// On breakpoint change
		if (bpLastValue !== bpValue || bpValue === 'xs') {
			if(this.current) {
				console.log(this.current);
				let $item = this.$cache.items.filter('[data-target="'+this.current+'"]');
				console.log($item);
				let $content = $item.find('.pi-content');
				let $contentInner = $content.find('.inner-content');
				let h = $contentInner.outerHeight();
				
				console.log(h);
				gsap.set($content, {height: h});
			}
		}
	}
	
	init() {
		let $item = this.$cache.items.eq(0);
		let $content = $item.find('.pi-content');
		let $contentInner = $content.find('.inner-content');
		let h = $contentInner.outerHeight();
		
		this.current = $item.data('target');
		
		gsap.set($content, {height: h});
		gsap.set($contentInner, {opacity: 1});
	}

    changeItem(e) {
    	let $el = $(e.currentTarget);
		let $parent = $el.parent();
		let current = $parent.data('target');
		
		if(this.current === current) return false;
		
		this.current = current;
		
		this.close(this.$cache.items.filter('.is-open'));
		this.open($parent);
    }
	
	open(el) {
		let $content = el.find('.pi-content');
		let $contentInner = $content.find('.inner-content');
		
		let $dkContent = this.$cache.itemsContent.filter('[data-index="'+this.current+'"]');
		let $dkContentItems = $dkContent.find('.ic-picto');
		
		el.addClass('is-open');
	
		let h = $contentInner.outerHeight();
		let tl = new gsap.timeline({paused: true});
	
		tl.add(() => {
			el.trigger('opening');
			$dkContent.addClass('is-current');
		}, 0);
		tl.to($content, 0.5, {height: h, force3D: true, ease: "quad.out"}, 0.05);
		
		if ((window.bp.value !== 'sm' && window.bp.value !== 'xs' && window.bp.value !== 'md')) {
			tl.fromTo($contentInner, 0.6, {x: 50}, {x: 0, ease: "circ.out"}, 0.15);
			tl.fromTo($contentInner, 0.5, {opacity: 0}, {opacity: 1, ease: "quad.out"}, 0.15);
		} else {
			tl.fromTo($contentInner, 0.6, {y: 100}, {y: 0, ease: "circ.out"}, 0.15);
			tl.fromTo($contentInner, 0.5, {opacity: 0}, {opacity: 1, ease: "quad.inOut"}, 0.15);
		}
		
		tl.fromTo($dkContentItems, 0.5, {opacity: 0}, {opacity: 1, ease: "quad.out", stagger: 0.05}, 0.15);
		tl.fromTo($dkContentItems, 0.6, {x: 50}, {x: 0, ease: "circ.out", stagger: 0.05}, 0.15);
	
		tl.play();
	}
	
	close(el) {
		let $content = el.find('.pi-content');
		let $contentInner = $content.find('.inner-content');
		
		let $dkContent = this.$cache.itemsContent.filter('.is-current');
		let $dkContentItems = $dkContent.find('.ic-picto');
		
		let tl = new gsap.timeline({paused: true, onStart: () => {
			el.trigger('closing');
			el.removeClass('is-open');
		}, onComplete: () => {
			$dkContent.removeClass('is-current');
		}});
		tl.to($contentInner, {duration: 0.4, opacity: 0, ease: "expo.out"}, 0.1);
		tl.to($content, {duration: 0.5, height: 0, ease: "quad.out"}, 0);
		
		tl.to($dkContentItems, {duration: 0.4, opacity: 0, ease: "expo.out"}, 0);
	
		tl.play();
	}
}

export default PrivateLabel;


// WEBPACK FOOTER //
// ./scripts/components/private-label.js